import { getHotelNews } from 'actions/news';
import { getHotelMeta } from 'actions/hotel';

export default store => ({
	path: ':id',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./container.js').default;
					cb(null, component);
				},
				'News',
			),
		onEnter: ({ params: { lang, hotel, id } }) => {
			store.dispatch(getHotelNews(lang, hotel, id));
			store.dispatch(getHotelMeta(lang, hotel, 'promotions'));
		},
	},
});



// WEBPACK FOOTER //
// ./src/routes/Hotel/News/News/index.js